// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__BcB3F","col":"styles_col__bKm5A","fulfillmentStatus":"styles_fulfillmentStatus__3AkXp","emailCol":"styles_emailCol__3sr8f"};